import Collapse from '@mui/material/Collapse'
import { default as List, default as ListItem } from '@mui/material/List'
import { Fragment, useState } from 'react'
import { NavLink } from 'react-router-dom'
import './style.css'

import Logo from '../../images/logo-2.png'

const menus = [
  {
    id: 1,
    title: 'Home',
    link: '/home',
  },

  {
    id: 2,
    title: 'About Us',
    link: '/about',
    // submenu: [
    //     {
    //         id: 21,
    //         title: 'About Us',
    //         link: '/about'
    //     },
    //     {
    //         id: 22,
    //         title: 'Services',
    //         link: '/services'
    //     },
    //     {
    //         id: 23,
    //         title: 'Service single',
    //         link: '/service-single/Custom-Solutions'
    //     },
    //     {
    //         id: 24,
    //         title: 'Team',
    //         link: '/team'
    //     },
    //     {
    //         id: 25,
    //         title: 'Team single',
    //         link: '/team-single/Robert-Fox'
    //     },
    //     {
    //         id: 26,
    //         title: 'Pricing',
    //         link: '/pricing'
    //     },
    //     {
    //         id: 27,
    //         title: 'Login',
    //         link: '/login'
    //     },
    //     {
    //         id: 28,
    //         title: 'Contact Us',
    //         link: '/contact'
    //     },
    //     {
    //         id: 29,
    //         title: 'Privace',
    //         link: '/privace'
    //     },
    //     {
    //         id: 221,
    //         title: 'Terms',
    //         link: '/terms'
    //     },
    //     {
    //         id: 222,
    //         title: '404 Error',
    //         link: '/404'
    //     },
    // ]
  },

  {
    id: 3,
    title: 'Home Supplies',
    link: '/projects',
  },

  {
    id: 4,
    title: 'Construction Materials',
    link: '/services',
  },
  {
    id: 5,
    title: 'Contact',
    link: '/contact',
  },
]

const MobileMenu = () => {
  const [openId, setOpenId] = useState(0)
  const [menuActive, setMenuState] = useState(false)

  const ClickHandler = () => {
    window.scrollTo(0, 0)
  }

  return (
    <div>
      <div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
        {/* <div className="row"> */}
       <div className="menu-logo">
  <div className="logo widget-title">
    <img src={Logo} alt="blog" />
  </div>
  <div className="menu-close">
    <div className="clox" onClick={() => setMenuState(!menuActive)}>
      <i className="ti-close"></i>
    </div>
  </div>
</div>
        {/* </div> */}

        <ul className="responsivemenu">
          {menus.map((item, mn) => {
            return (
              <ListItem
                className={item.id === openId ? 'active' : null}
                key={mn}
              >
                {item.submenu ? (
                  <Fragment>
                    <p
                      onClick={() =>
                        setOpenId(item.id === openId ? 0 : item.id)
                      }
                    >
                      {item.title}
                      <i
                        className={
                          item.id === openId
                            ? 'fa fa-angle-up'
                            : 'fa fa-angle-down'
                        }
                      ></i>
                    </p>
                    <Collapse
                      in={item.id === openId}
                      timeout="auto"
                      unmountOnExit
                    >
                      <List className="subMenu">
                        <Fragment>
                          {item.submenu.map((submenu, i) => {
                            return (
                              <ListItem key={i}>
                                <NavLink
                                  onClick={ClickHandler}
                                  className="active"
                                  to={submenu.link}
                                >
                                  {submenu.title}
                                </NavLink>
                              </ListItem>
                            )
                          })}
                        </Fragment>
                      </List>
                    </Collapse>
                  </Fragment>
                ) : (
                  <NavLink className="active" to={item.link}>
                    {item.title}
                  </NavLink>
                )}
              </ListItem>
            )
          })}
        </ul>
      </div>

      <div
        className="showmenu mobail-menu"
        onClick={() => setMenuState(!menuActive)}
      >
        <button type="button" className="navbar-toggler open-btn">
          <span className="icon-bar first-angle"></span>
          <span className="icon-bar middle-angle"></span>
          <span className="icon-bar last-angle"></span>
        </button>
      </div>
    </div>
  )
}

export default MobileMenu
